<template>
  <div class="container main-content clearfix">
    <div class="shortcodes">
      <div class="sixteen columns bottom-3">
        <div v-if="ctatext" class="qoute">
          <div class="one columns omega">&nbsp;</div>
          <div class="seven columns omega">
            <h4>{{ ctatext }}</h4>
            <p>{{ $t('banner_text_month', {month: month}) }}</p>
          </div>
          <div class="seven columns alpha">
            <router-link :to="{ name: 'contact' }"
                         class="button medium color">
              {{ $t('banner_button_meeting') }}
            </router-link>
          </div>
          <div class="one columns omega">&nbsp;</div>
        </div>
        <div v-else class="qoute">
          <div class="eleven columns omega">
            <h4>{{ $t('banner_ctatext2') }}</h4>
            <p>{{ $t('banner_ctatext3') }}</p>
          </div>
          <div class="four columns alpha">
            <router-link :to="{ name: 'contact' }"
                         class="center button medium color">
              {{ $t('banner_button_contact') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Contact',
    props: ['ctatext'],
    data () {
      return {
        localeString : '',
      }
    },
    computed: {
      month () {
        if (this.localeString.length < 2) return ''
        return new Date().toLocaleString(this.localeString, { 'month': 'long' })
      }
    },
    mounted () {
      this.localeString = this.$t('localeString')
    }
  }
</script>

<style scoped>
    .center { text-align:center; }
</style>
